import { AlwaysAnimatedMaterialOptions } from "@/types";
import { MeshPhysicalMaterial, MeshPhysicalMaterialParameters } from "three";

export const SoapTransparentMaterial = async (args = {}) => {
	const material = new MeshPhysicalMaterial(
		Object.assign(
			{
				transmission: 1.05,
				thickness: 0,
				roughness: 0,
				ior: 1,
				iridescence: 1,
				iridescenceIOR: 1,
				reflectivity: 0.1,
				attenuationDistance: 1,
				iridescenceThicknessRange: [0, 1800],
				clearcoat: 1,
				clearcoatRoughness: 0,
				envMapIntensity: 0.1,
			},
			args
		) as MeshPhysicalMaterialParameters
	);

	// Object.assign(material, args);

	const uniforms = {
		time: { value: 0 },
	};

	// Vertex Shader für Noise-Verformung erweitern
	material.onBeforeCompile = (shader) => {
		shader.uniforms.time = uniforms.time;

		shader.vertexShader = shader.vertexShader.replace(
			`void main() {`,
			`

      float random(vec2 st) {
          return fract(sin(dot(st.xy, vec2(12.9898, 78.233))) * 43758.5453123);
      }

      float noise(vec2 st) {
          vec2 i = floor(st);
          vec2 f = fract(st);
          float a = random(i);
          float b = random(i + vec2(1.0, 0.0));
          float c = random(i + vec2(0.0, 1.0));
          float d = random(i + vec2(1.0, 1.0));
          vec2 u = f * f * (3.0 - 2.0 * f);
          return mix(a, b, u.x) + (c - a) * u.y * (1.0 - u.x) + (d - b) * u.x * u.y;
      }


      uniform float time;
      void main() {
      `
		);

		shader.vertexShader = shader.vertexShader.replace(
			`#include <begin_vertex>`,
			`
        #include <begin_vertex>
        // Original Position
        // vec3 transformed = vec3(position);
        
        // Verforme die Vertices leicht mit Noise
        float deformation = 0.2 * noise(position.xy + vec2(time));
        transformed += normal * deformation;
      
      `
		);
	};

	material.userData.always_animated = (opt: AlwaysAnimatedMaterialOptions) => {
		uniforms.time.value += opt.clock.getDelta();
	};

	return material;
};
